export default __webpack_public_path__ + "static/media/Bot-Work-In-Progress-2.164ca790.jpg";